module.exports = __webpack_public_path__ + "static/Corey Drake.b7de4b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Corey Drake.jpg
// module id = 1147
// module chunks = 35783957827783